import { render, staticRenderFns } from "./template.html?vue&type=template&id=04b40ceb&scoped=true&"
import script from "./new.vue?vue&type=script&lang=js&"
export * from "./new.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=04b40ceb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b40ceb",
  null
  
)

export default component.exports